import React from "react";
import ReactApexChart from "react-apexcharts";
import { buildChartData } from "../utils/chartDataUtils";

const TrendBadge = ({ trend }) => {
  if (!trend) return null;
  const { percent, direction } = trend;
  const cls = `widgetCardTrendBadge widgetCardTrendBadge${
    direction === "up" ? "Up" : direction === "down" ? "Down" : "Neutral"
  }`;
  const arrow = direction === "up" ? "↑" : direction === "down" ? "↓" : "—";
  const sign = direction === "up" ? "+" : direction === "down" ? "-" : "";
  const label = percent != null ? `${sign}${Math.abs(percent).toFixed(0)}% vs prev. period` : "";
  return (
    <div className={cls}>
      <span className="trendArrow">{arrow}</span>
      <span>{label}</span>
    </div>
  );
};

const buildChartOptions = (labels, isSingleDay, max, metricLabel) => ({
  chart: {
    type: "area",
    toolbar: { show: false },
    animations: { enabled: false },
    selection: { enabled: false },
    zoom: { enabled: false }
  },
  stroke: { curve: "smooth", width: 2 },
  markers: {
    size: isSingleDay ? 5 : 3,
    colors: ["#3953fb"],
    strokeColors: "#fff",
    strokeWidth: 2,
    hover: { size: isSingleDay ? 6 : 4 }
  },
  fill: {
    type: "solid",
    opacity: 0.2
  },
  colors: ["#3953fb"],
  dataLabels: { enabled: false },
  xaxis: {
    categories: labels,
    labels: { show: isSingleDay, style: { fontSize: "11px" } },
    axisBorder: { show: false },
    axisTicks: { show: false }
  },
  yaxis: {
    min: 0,
    max,
    tickAmount: 4,
    labels: { show: isSingleDay, style: { fontSize: "11px" } }
  },
  grid: {
    borderColor: "#e8ebee",
    strokeDashArray: 3,
    padding: { left: 0, right: 0, top: 0, bottom: 0 },
    yaxis: { lines: { show: true } },
    xaxis: { lines: { show: false } }
  },
  tooltip: {
    y: {
      title: { formatter: () => (metricLabel ? `${metricLabel}:` : "") },
      formatter: val => Math.round(val).toLocaleString()
    }
  }
});

const CountWidget = ({ value, trend, series, dateFilter, metricLabel }) => {
  const displayValue = value != null ? value.toLocaleString() : "—";
  const hasSeries = Array.isArray(series) && series.length > 0;

  const chartData = hasSeries ? buildChartData(series, dateFilter) : [];
  const isSingleDay = chartData.length === 1;
  const labels = chartData.map(d => d.label);
  const values = chartData.map(d => d.value || 0);
  const apexSeries = chartData.length > 0 ? [{ name: "Count", data: values }] : [];
  // ApexCharts can't draw a meaningful line when min === max === 0 (an all-zero
  // series), so fall back to 1 the same way CallOutcomesWidget/CallsByMemberWidget do.
  const dynamicMax = Math.max(...values, 1);
  const options = buildChartOptions(labels, isSingleDay, dynamicMax, metricLabel);

  return (
    <>
      <div className="widgetCardValue">{displayValue}</div>
      <TrendBadge trend={trend} />
      {apexSeries.length > 0 && (
        <div className="rateWidgetChartWrap">
          <ReactApexChart
            options={options}
            series={apexSeries}
            type="area"
            height={140}
          />
        </div>
      )}
    </>
  );
};

export default CountWidget;
